import axios from 'axios'
import { formatDate } from '../helpers/UtilityHelper'
import { endOfMonth, startOfMonth, subDays, subMonths } from 'date-fns'

const ENDPOINT = process.env.REACT_APP_ENDPOINT
// const ENDPOINT = 'http://localhost:8099/api/'
const ENDPOINT2 = process.env.REACT_APP_ENDPOINT_EXT
// const ENDPOINT = 'https://proship.prozo.com/api/'
//const ENDPOINT2 = 'https://proship.prozo.com/ext/api/'
export const apiConstants = {
  BASE_LOCAL: ENDPOINT,
  BASE_LOCAL2: ENDPOINT2,
  // Revokes the presented JWT server-side and drops the refresh session (CWE-613).
  LOGOUT: 'auth/logout',
  // ── D2C Freight Pricing (all under {ENDPOINT}d2c/... i.e. /api/d2c) ──
  D2C_PROPOSALS: 'd2c/proposals',
  D2C_PROPOSAL_VERSIONS: 'd2c/proposal-versions',
  D2C_CONFIG: 'd2c/config',
  D2C_ADMIN_PROPOSALS: 'd2c/admin/proposals',
  D2C_ADMIN_PINCODE_IMPORT: 'd2c/admin/masters/pincodes/import',
  D2C_MASTERS_PINCODES: 'd2c/masters/pincodes',
  D2C_MASTERS_ZONE: 'd2c/masters/zone',
  D2C_MASTERS_COURIERS: 'd2c/masters/couriers', // per FE Integration Guide §22 (returns cpAccountCode)
  // ── GrowthOS migration — Brands master data (day-one slice) ──
  // Deliberately NOT growthos/... — that prefix is the separate, live
  // GrowthOsReportingController the still-running standalone GrowthOS app polls today.
  GROWTHOS_ADMIN_BRANDS: 'growthos-admin/brands',
  GROWTHOS_ADMIN_PEOPLE: 'growthos-admin/people',
  GROWTHOS_ADMIN_DEALS: 'growthos-admin/deals',
  GROWTHOS_ADMIN_BUDGET: 'growthos-admin/budget',
  GROWTHOS_ADMIN_SME_TARGETS: 'growthos-admin/sme-targets',
  GROWTHOS_ADMIN_SALES_POC_ANALYTICS: 'growthos-admin/analytics/sales-pocs',
  GROWTHOS_ADMIN_REVENUE_ROLLUP: 'growthos-admin/revenue-rollup',
  GROWTHOS_ADMIN_CONNECTORS: 'growthos-admin/connectors',
  GROWTHOS_ADMIN_HUBSPOT: 'growthos-admin/hubspot',
  GROWTHOS_ADMIN_RETENTION: 'growthos-admin/analytics/retention',
  GROWTHOS_ADMIN_SME: 'growthos-admin/analytics/sme',
  GROWTHOS_ADMIN_EXECUTIVE: 'growthos-admin/analytics/executive',
  GROWTHOS_ADMIN_DECISION_INSIGHTS: 'growthos-admin/analytics/decision-insights',
  GROWTHOS_ADMIN_MARKETING_FUNNEL: 'growthos-admin/analytics/marketing-funnel',
  GROWTHOS_ADMIN_PIPELINE_FUNNEL: 'growthos-admin/analytics/pipeline-funnel',
  GROWTHOS_ADMIN_HUBSPOT_REVIEW: 'growthos-admin/analytics/hubspot-review',
  GROWTHOS_ADMIN_EMAIL_MARKETING: 'growthos-admin/analytics/email-marketing',
  GROWTHOS_ADMIN_LINKEDIN_ABM: 'growthos-admin/linkedin-abm',
  // "Request a Campaign" — shared across every Marketing sub-page, not scoped to one channel.
  GROWTHOS_ADMIN_MARKETING_CAMPAIGN_REQUESTS: 'growthos-admin/marketing/campaign-requests',
  // ── RVP with QC (all under {ENDPOINT}qc/... i.e. /api/qc) — contract frozen before wiring ──
  QC_MERCHANTS: 'qc/merchants',
  QC_PARAMS: 'qc/params',
  QC_COURIER_MASTER: 'qc/courier-master',
  // ── KCI Event Tagging (all under {ENDPOINT}kci/... i.e. /api/kci) — branch PROSHIP-1261 ──
  KCI_BASE: 'kci',
  KCI_INTIMATION: 'kci/intimation',
  KCI_EVENT: 'kci/event',
  KCI_GEO: 'kci/geo',
  KCI_TAGGED_ORDERS: 'kci/tagged-orders',
  KCI_DASHBOARD: 'kci/dashboard',
  KCI_CONFIG: 'kci/config',
  // ── Sales Leadership Dashboard (KAM/SAM/SL, all under {ENDPOINT}sales/...) ──
  // /sales/dashboard/** reads and /sales/mapping/** CRUD (GET + POST add on
  // /{merchantOid}; PUT/DELETE per role; PUT priority) are open to Proship
  // admins (any merchant) and SALES_DASHBOARD holders (only merchants on their
  // own access list — enforced server-side). /sales/admin/rollup/backfill
  // stays admin-only. The courier KAM screen still posts to the legacy
  // admin-only ADD_KAM_DETAILS (system/default/kam).
  SALES_DASHBOARD_SUMMARY: 'sales/dashboard/summary',
  ALLOCATION_DASHBOARD_SUMMARY: 'allocation/dashboard/summary',
  ALLOCATION_DASHBOARD_RCA_SUMMARY: 'allocation/dashboard/rca/summary',
  ALLOCATION_DASHBOARD_RCA_ROWS: 'allocation/dashboard/rca/rows',
  SALES_DASHBOARD_TREND_MONTHLY: 'sales/dashboard/trend/monthly',
  SALES_DASHBOARD_TREND_DAILY: 'sales/dashboard/trend/daily',
  SALES_MAPPING: 'sales/mapping',
  SALES_ADMIN_ROLLUP_BACKFILL: 'sales/admin/rollup/backfill',
  AUTH: 'auth/signin',
  ORDER_SEARCH: 'order/search',
  ORDER_MERCHANT_ZONE_SOURCE: 'order/merchantZoneSource', // ?orderId= → {source: DEFAULT|OVERRIDE|null, stored, liveZone}
  MERCHANT: 'merchant',
  MERCHANT_CREATE: 'merchant/create',
  MERCHANT_ONBOARDING_INIT: 'merchant', // used as merchant/{id}/onboarding/init
  MERCHANT_DETAILS: 'config/merchant',
  MERCHANT_ALLOCATION_VISIBILITY: 'config/merchant/allocation-visibility',
  MERCHANT_RATECARD_VISIBILITY: 'config/merchant/ratecard-visibility',
  MERCHANT_CHANNELORDERS_VISIBILITY: 'config/merchant/channelorders-visibility',
  MERCHANT_RETURNS_VISIBILITY: 'config/merchant/returns-visibility',
  MERCHANT_DIRECT_VISIBILITY: 'config/merchant/direct-visibility',
  MERCHANT_SEARCH: 'merchant/search',
  MERCHANT_SEARCH_CACHED: 'merchant/searchCached',
  COURIERS: 'courierPartner',
  COURIER_PARTNER_SEARCH: 'courierPartner/search',
  COURIER_PARTNER_SEARCH_CACHED: 'courierPartner/searchCached',
  COURIER_PARTNER_SEARCH_REPORT_ELIGIBLE: 'courierPartner/searchReportEligible',
  COURIER_LOGICAL_NAME_BACKFILL: 'courierPartner/backfill-logical-name', // POST, PROSHIPADMIN — recompute derived logical_name for every live courier
  PAYMENT_MODE_GUARD: 'ops/payment-mode-guard', // GET ?days=N — wrong-payment-mode orders per restricted courier account
  PAYMENT_MODE_GUARD_ORDERS: 'ops/payment-mode-guard/orders', // GET ?courierId=&days=N — the AWBs behind one row, with cause
  /* Courier Setup (supply-side) — parent couriers + agreements */
  COURIER_PARENT: 'courierPartner/parent',
  COURIER_PARENT_AGREEMENT: 'courierPartner/parent/agreement',
  COURIER_QC_CONFIG: 'config/qc/questionList',
  /* PCIS/Direct-Integration admin API — proxied through ProShip's own backend
     (BASE_LOCAL), not a separate host. See the proxy's own route table for the
     full set (list/one/create/update/deactivate) — only lookup + create are used here. */
  PCIS_COURIER_ACCOUNTS: 'pcis-admin/courier-accounts',
  PCIS_COURIER_PARTNERS: 'pcis-admin/courier-partners', // append /{courierCode}?service_type=...
  PCIS_HEALTH_SUMMARY: 'pcis-admin/health/summary',
  PCIS_HEALTH_ORDERS: 'pcis-admin/health/orders',
  /* PCIS dashboard aggregates. All eight take the same filter set as summary/orders
     (from, to, courier, account, merchant, channel, routingMode, orderType,
     deliveryType, onlyFailed); the backend caches them for 60s. */
  PCIS_HEALTH_OVERVIEW: 'pcis-admin/health/overview',
  PCIS_HEALTH_TIMESERIES: 'pcis-admin/health/timeseries',
  PCIS_HEALTH_BREAKDOWN: 'pcis-admin/health/breakdown',
  PCIS_HEALTH_FAILURES: 'pcis-admin/health/failures',
  PCIS_HEALTH_LIFECYCLE: 'pcis-admin/health/lifecycle',
  PCIS_HEALTH_LATENCY: 'pcis-admin/health/latency',
  PCIS_HEALTH_ADOPTION: 'pcis-admin/health/adoption',
  PCIS_HEALTH_EVENTS: 'pcis-admin/health/events',
  /* Native (Direct Integration) order counts for a date range, broken down
     parent -> courier -> account. Takes from/to as yyyy-MM-dd'T'HH:mm:ss.

     PCIS only stores orders it routed NATIVELY, so `nativeOrders` is the only
     meaningful figure here: `totalOrders` equals it, and `clickpostOrders` is
     structurally 0 — it does NOT mean there was no Clickpost volume. Clickpost
     volume is derived by subtracting this from Proship's own order count (see
     usePcisNativeVolumeQuery / TabOverview). */
  PCIS_NATIVE_VOLUME: 'pcis-order-report/registration-breakdown',
  /* Direct Integration vs Clickpost volume, per parent courier AND per time bucket, computed by
     Proship rather than PCIS — PCIS stores only the orders it routed natively, so the Clickpost
     side of the split exists nowhere else.

     Takes from/to as yyyy-MM-dd'T'HH:mm:ss plus bucket=DAY|HOUR (HOUR capped at a 7-day window,
     the whole thing at 92 days). One response carries every view the dashboard needs — totals,
     byCourier, buckets, and courierBuckets for the per-courier trend — so a courier filter is a
     client-side filter over pre-aggregated rows rather than another round trip. */
  PCIS_ROUTING_SPLIT: 'pcis-admin/health/routing-split',
  ZONEMAP: 'zonemap', // CP zone-mapping — base seed + overrides + publish
  CANCEL_PENDING_RATECARD: 'tools/cancelPendingRateCard',
  TRACK_ORDER: 'order/track_waybill',
  TRACK_VIA_FILE: 'order/track_uploaded_orders',
  SERVICEABILITY: 'tools/serviceability',
  SERVICEABILITY_UPLOAD: 'tools/upload/servicability',
  GET_ORDER: 'report/orders',
  TOOL_LOGS: 'tools/logs/search',
  TOOL_LIST_ZONE: 'tools/listzone',
  TOOL_PINCODE_ZONE_FACTS: 'tools/pincode/zoneFacts',
  TOOL_ZONE_OVERRIDE_PAGE: 'tools/zoneoverride/page',
  TOOL_FETCH_ZONE_MAP: 'tools/fetchZoneMap',
  TOOL_MERCHANT_ZONE: 'tools/merchantZone',
  COD_CONFIG: 'cod/codConfig',
  COD_REPORT_JSON: 'cod/report/json',
  COD_MERCHANT_REPORT: 'cod/filter/report',
  REPORT_ACTION: 'cod/report/action',
  UPLOAD_SERVICEABILITY: 'tools/upload/servicability',
  GET_ALL_REPORTS: 'reports/get/merchant',
  GET_ALL_REPORT_TYPES: 'reports/types',
  GET_REPORT_TYPE_DETAILS: 'reports/types/details',
  CREATE_REPORT_ASYNC: 'reports/getAsync',
  FINANCE_PROFIT: 'aggregate/finance/diff',
  DOWNLOAD_SAMPLE_FILE: 'order/Download_samples',
  UPLOAD_MERCHANT_RULE: 'tools/upload/MERCHANT_RULE',
  REFRESH_URL: 'tools/refresh/url',
  COD_CONFIG_UPDATE: 'cod/codConfigUpdate',
  RECALCULATE_PRICE: 'tools/recalculate_pricing',
  RECALCULATE_SLA: 'tools/recalculateSLA',
  WALLET: 'wallet/merchantWallet',
  SLA: 'shipment/TAT',
  KYC_APPROVAL: 'merchant/verifyKycDocuments',
  ENABLE_WALLET: 'wallet/enableMerchantWallet',
  CREATE_WALLET: 'wallet/createUpate',
  UPDATE_OFFLINE: 'wallet/changeofflinebalance',
  UPLOADS_REMARKS: 'remarks/upload',
  REMARKS: 'remarks/get',
  SAVE_REMARKS: 'remarks/save',
  COD_UPLOAD: 'cod/uploadremittancecsv/courier',
  COD_ACTION: 'cod/report/action',
  CREATE_ORDER: 'order/createUnprocessedOrder',
  BULK_UPLOAD: 'order/bulk_upload_register_tracking',
  BULK_PTL_PUR: 'b2b/pickup/bulk_pickup_orders_B2B',
  BULK_UPLOAD_B2B_TRACK: 'b2b/tracking/v2/bulk_tracking_b2b_upload',
  B2B_BULK_ORDER_CREATE: 'async/b2b/order/Bulk_order_create',
  BULK_UPLOAD_ADDNL_CHARGES: 'b2b/upload/additional_charges',
  PTL_PUR_SEARCH: 'b2b/pickup/search',
  RESYNC_ORDER: 'order/refreshWaybillStatus',
  // Delete-and-Resync (status-history correction) — proship proxies preview/apply to the resync lambda;
  // backups/restore are native proship (order_history_resync_backup collection, 7-day TTL).
  RESYNC_PREVIEW: 'order-resync/preview',
  RESYNC_APPLY: 'order-resync/apply',
  RESYNC_BACKUPS: 'order-resync/backups', // append /{awb}
  RESYNC_RESTORE: 'order-resync/restore',
  MANUAL_STATUS: 'order/updateStatus',
  PICKUP_LOCATION: 'merchant/register_pickup',
  DELIVERY_LOCATION: 'merchant/delivery_location',
  ADD_DELIVERY_LOCATION: 'merchant/save_delivery_location',
  KYC_UPLOAD: 'merchant/submit_kyc_details',
  MERCHANT_ADD_MANDATORY_FIELDS: 'merchant/addMandatoryFields',
  MERCHANT_UPDATE_BANK: 'merchant/update_bankDetails',
  UPLOAD_AGREEMENT: 'merchant/uploadSignedDocument',
  WEIGHT_FREEZE: 'system/default/uploadWeightFreeze',
  CASH_FLOW: '/cod/report/cashFlow',
  UPLOADS_PODS: 'order/upload_pods',
  PODS: 'order/uploadPod',
  FILE_CONVERSION_UPLOAD: 'file-conversion/upload-to-s3',
  FILE_CONVERSION_FORMATS: 'file-conversion/supported-formats',
  INVOICE_UPLOAD: 'finance/courierInvoice/upload',
  WEIGHT_DISCREPANCY: 'tools/weight_discrepancy/filter',
  WEIGHT_DISCREPANCY_UPDATE: 'tools/weight_discrepancy/update',
  IMAGE_UPLOAD_WEIGHT_DISCREPANCY: 'tools/wd/submit_images',
  WEIGHT_DISCREPANCY_LINK_UPLOAD: 'tools/wd/submit_image_links',
  // ── Weight v2 (fresh admin module, pages/WeightV2) — proship_mongo weightv2/* controllers ──
  WD_V2_LIST: 'v2/wd/list',
  WD_V2_SUMMARY: 'v2/wd/summary',
  WD_V2_BASE: 'v2/wd', // append /{id}
  WF_V2_REQUESTS: 'v2/wf/requests',
  WF_V2_BASE: 'v2/wf', // append /counts, /{id}, /{id}/request-info|approve|reject
  MERCHANT_CONFIG_BASE: 'config/merchant', // append /{id}; /{id}/wdAutoClosureDays?days=
  DELIVERY_DB_SEARCH: 'tools/generic/deliveryDB/search',
  COD_RECONCILIATION: 'cod/filter/orderV2',
  COD_AGGREGATE: 'cod/codAggregate',
  CANCEL_ORDER: '/order/cancel_order',
  REPORT_GENERIC_SEARCH: 'tools/generic/search',
  WEBHOOK: 'merchant/webHookUpdate',
  WEBHOOK_SEARCH: 'merchant/webHooks/',
  CHANNEL_WEBHOOK_SEARCH: 'merchant/channelWebHooks/',
  LIST_MODULE: 'auth/listmodules',
  CREATE_USER: 'auth/user_signup',
  UPDATE_USER_ACTION: 'auth/accountAction',
  GET_MERCHANT_USERS: 'auth/users',
  UPDATE_ACCESS_LIST: 'auth/update_role',
  BULK_DOWNLOAD_POD: 'tools/getBulkPodsAndPdfZip',
  GET_USER: 'auth/search',
  INTERNAL_USERS: 'auth/internal-users',
  VALIDATE_GOOGLE_AUTH_CODE: 'auth/validateToken',
  CHANGE_PASSWORD: 'auth/set_password',
  RESET_PASSWORD: 'auth/reset_password',
  CHANNEL_ORDER_SEARCh: 'channel/order/search',
  GET_SKU_DIM: 'product/get/all',
  CREATE_REVERSE_ORDER: 'order/createReverseWithReference',
  CREATE_SELECTOR: 'selector/create',
  SEARCH_INVOICE: 'finance/orderInvoice/filter',
  FINANCE_UPLOAD_INVOICE: 'finance/orderInvoice/financeUpload',
  GENERATE_MERCHANT_INVOICE: 'finance/orderInvoice/createMonthly',
  BULK_GENERATE_MERCHANT_INVOICE: 'finance/orderInvoice/createMonthly/bulk',
  BULK_GENERATE_MERCHANT_INVOICE_STATUS: 'finance/orderInvoice/createMonthly/bulk/status',
  BULK_GENERATE_MERCHANT_INVOICE_RECENT: 'finance/orderInvoice/createMonthly/bulk/recent',
  ACTION_INVOICE: 'finance/orderInvoice/action',
  COURIER_ORDER_INVOICE_UPLOAD: 'finance/courierOrderInvoice/upload',
  COURIER_ORDER_INVOICE_LIST: 'finance/courierOrderInvoice/list',
  GET_SKU: 'system/default',
  EDD_UPDATE: 'order/updateB2B_Order',
  GENERIC_UPDATE: 'tools/generic/update',
  CUSTOM_EDD_BULK_UPDATE: 'v1/orders/edd/bulk-update',
  CUSTOM_EDD_REASONS: 'v1/orders/edd/custom-edd-reasons',
  B2B_RESYNC: 'system/track/sync',
  MERCHANT_CONFIG: 'config/merchant',
  RULE_HISTORY: 'ruleengine/rule-history',
  TOGGLE_RETURN_CONFIG: 'returnAndExchangeOrder/updateReturnConfig',
  TRACKING_MY_CONFIG: 'merchantDesc/config/tracking/myConfig',
  TRACKING_SAVE_BRANDING: 'merchantDesc/config/tracking/saveBranding',
  TRACKING_ASSIGN_URL: 'merchantDesc/config/tracking/assignUrl',
  TRACKING_SET_LIVE: 'merchantDesc/config/tracking/setLive',
  TRACKING_LIST: 'merchantDesc/config/tracking/list',
  GET_EDD_REMARKS: 'tools/getEddRemarksData',
  COD_RECONCILIATION_DOWNLOAD: 'cod/filter/order',
  COURIER_MIS_UPLOAD: 'finance/courierMIS/upload',
  // ── Weight Ledger ────────────────────────────────────────────────────────
  WEIGHT_LEDGER: 'weight/ledger',
  WEIGHT_LEDGER_BY_AWB: 'weight/ledger', // append /{awbNumber}
  WEIGHT_LEDGER_MIS_UPLOAD: 'weight/ledger/mis/upload',
  WEIGHT_LEDGER_MIS_STATUS: 'weight/ledger/mis/upload', // append /{uploadId}/status
  WEIGHT_LEDGER_MIS_ERRORS: 'weight/ledger/mis/upload', // append /{uploadId}/errors
  WEIGHT_LEDGER_MIS_HISTORY: 'weight/ledger/mis/upload/history',
  REFRESH_FILE_URL: 'tools/refreshAnySignedUrl',
  RATE_CALCULATOR: 'tools/list/pricing',
  DEFAULT_PRICING: 'system/default/MERCHANT_PRICING',
  EASYECOM_WEBHOOK: '/merchant/channelWebHookUpdate',
  MERCHANT_UPDATE: 'merchant/update',
  UPLOAD_LOGO_IMAGE: '/tools/uploadImagesNonExpire',
  ADD_CHANNEL_CONFIG: 'channel/config/add',
  GET_CHNANNEL_CONFIG: 'channel/config/search',
  DEFAULT_UPLOAD: 'system/default/merchant',
  GET_CACHE: 'internal/cache/',
  CP_REFRESH_CONFIG: 'order/async/b2b/internal/refresh_config',
  WMS_WAREHOUSE: 'external/ct/controltower/v1/wms/warehouse',
  SERVICEABILITY_INTEL_GROUPS: 'order/serviceability/intel/setup/groups',
  TAT_MERCHANTS: 'tat/merchants',
  TAT_STANDARD: 'tat/standard',
  DASHBOARD_CONTROLTOWER: 'external/ct/controltower/v1/wms/freightsnapshot/dashboard',
  DASHBOARD_UNPROCESSED_TREND: 'aggregate/dashboard/unprocessed/trend',
  DASHBOARD_DAILY_TREND: 'aggregate/dashboard/trend',
  UPLOAD_BULK_ACTION: 'finance/wd/bulkAction',
  GET_BULK_ACTION_WD: 'finance/wd/bulkActionStatus',
  DASHBOARD_CONTROLTOWER_DATEWISE_AWB_REGISTERED:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_awb_registered_orders_today_grouped_by_mechant',
  DASHBOARD_CONTROLTOWER_DATEWISE_RTO_DELIVERED:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_rto_delivered_orders_today_grouped_by_mechant',
  DASHBOARD_CONTROLTOWER_DATEWISE_AWB_REGISTERED_TODAY:
    'external/ct/controltower/v1/wms/freightsnapshot/all_awb_registered_orders_today_grouped_by_mechant',
  get_specific_data_delivery:
    'external/ct/controltower/v1/wms/freightsnapshot/getSpecificData/delivery',
  get_specific_data_pickup:
    'external/ct/controltower/v1/wms/freightsnapshot/getSpecificData/pickup',
  ADD_PICKUP_EMIALID: 'b2b/pickup/update_pickup_email',
  AUTO_ALLOCATE_COURIER: 'b2b/pickup/allocate_courier_auto',
  MANUAL_ALLOCATE_COURIER: 'b2b/pickup/allocate_courier',
  MANUAL_CANCEL_COURIER: 'b2b/pickup/cancel_request',
  CLOSE_PICKUP: 'b2b/pickup/close',
  GENERATE_PICKUP_REQUEST: 'b2b/pickup/pickup_request',
  UPLOAD_COURIER_ZONES: 'b2b/upload/courier/zones',
  UPLOAD_COURIER_PRICING: 'b2b/upload/merchant/price/b2b',
  UPLOAD_MERCHANT_B2B_ZONES: 'b2b/upload/merchant/zones',
  CREATE_PICKUP_REQUEST: 'b2b/pickup/create',
  BULK_QUICK_PICKUP_CREATE: 'b2b/pickup/quick/bulk_create',
  DASHBOARD_CONTROLTOWER_DATEWISE_DELIVERED:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_delivered_orders_today_grouped_by_mechant',
  RECALCULATE_EDD: 'tools/recalculateSLA',
  ADD_KAM: 'system/default/kam',
  DOWNLOAD_POD: 'tools/downloadPODs',
  GET_ALL_WALLET: 'wallet/merchantWallet',
  ORDER_TRANSACTION: 'wallet/gettransactionsfororders',
  OTHER_TRANSACTION: 'wallet/gettransactionsnonorder',
  WALLET_STATEMENT: 'wallet/statement',
  TOGGLE_SERVICABLITY: 'merchant/update',
  B2B_ORDER_STATUS_SYNC: 'system/track/sync',
  B2B_ORDER_FETCH_LABEL: 'order/async/b2b/fetch_label',
  B2B_ORDER_RE_MANIFEST: 'order/async/b2b/manifest',
  B2B_ORDER_STATUS_SYNC_POD: 'system/track/syncPOD',
  DOWNLOAD_SAMPLE_LOCATION: 'order/Download_samples',
  UPLOAD_LOCATION: 'merchant/upload_pickup_locations',
  UPLOAD_DELIVERY_LOCATIONS: 'merchant/upload_delivery_location',
  GET_BULK_LABELS: 'tools/getBulkLabelsAndPdfZipComma',
  FETCH_KAM_DETAILS: 'system/default/kam/MERCHANT',
  ADD_KAM_DETAILS: 'system/default/kam',
  COPY_ZONE: 'tools/add_cp_map',
  CREATE_CN: 'cn/newcn',
  GET_CN_LIST: 'cn/getByFilter',
  CN_ACTION: 'cn/action',
  MERCHANT_CN_UPLOAD: 'merchant-cn/upload',
  MERCHANT_CN_UPLOAD_ALLOW_DUPLICATES: 'merchant-cn/upload-allow-duplicates',
  MERCHANT_CN_GET_BY_FILTER: 'merchant-cn/getByFilter',
  MERCHANT_CN_AWB_REPORT: 'merchant-cn/awb-report',
  MERCHANT_CN_REASONS: 'merchant-cn/cn-reasons',
  NDR_BULK_UPLOAD: 'ndr/bulkAction',
  NPR_BULK_UPLOAD_V2: 'npr/newBulkAction',
  GET_BULK_UPLOAD_NPR: 'npr/bulkActionStatus',
  GET_BULK_UPLOAD_NDR: 'ndr/bulkActionStatus',
  RESET_TERMINAL_STATUS_BULK: 'tools/orders/reset-terminal-status',
  RESET_TERMINAL_STATUS_STATUS: 'tools/orders/reset-terminal-status/status',
  SY_STATUS_MAP: 'config/shipyaari/statusSubStatusAdd',
  SY_COURIER_MAP: 'config/shipyaari/courierMap',
  SY_CREDENTIAL_CONFIG_MAP: 'config/shipyaari/syCredentialConfig',
  B2B_RATE_CARD: 'tools/activeB2Bsla',
  GET_COURIER_MAP_STATUS: 'system/status/map/fetch',
  ADD_UPDATE_COURIER_MAP_STATUS: 'system/status/map/save',
  DELETE_COURIER_MAP_STATUS: 'system/status/map/delete',
  UPLOAD_COURIER_MAP_STATUS: 'system/status/map/upload',
  LOST_AND_DAMAGE_REPORT: 'lostdamage/report/filter',
  LOST_AND_DAMAGE_ACTIONWITHFILE: 'lostdamage/report/actionWithFile',
  LOST_AND_DAMAGE_ACTION: 'lostdamage/report/action',
  NDR_AUTOMATED_RULE_UPLOAD: 'ndr/automatedRule/fileUpload',
  NPR_AUTOMATED_RULE_UPLOAD: 'npr/automatedRule/fileUpload',
  NDR_AUTOMATED_RULE_DOWNLOAD: 'ndr/automatedRule/fileDownload',
  NPR_AUTOMATED_RULE_DOWNLOAD: 'npr/automatedRule/fileDownload',
  NDR_AUTOMATED_RULE_LIST: 'ndr/automatedRule/allMerchant',
  NPR_AUTOMATED_RULE_LIST: 'npr/automatedRule/allMerchant',
  RAZORPAY_MONTHLY_DUMP: 'finance/razorpay/monthly-dump',
  MIS_PROCESS_STATUS: 'finance/wd/misProcessStatus',
  UPDATE_CUSTOMER_DETAILS: 'channel/order/updateCustomer',
  MIS_PROCESS_DOWNLOAD: 'finance/wd/misProcessCSV',
  UPLOAD_EINVOICE: 'finance/orderInvoice/actionupload',
  INVOICE_CORRECTIONS_UPLOAD: 'invoice-corrections/upload',
  INVOICE_CORRECTIONS_FILTER: 'invoice-corrections/getByFilter',
  INVOICE_CORRECTIONS_REASONS: 'invoice-corrections/correction-reasons',
  INVOICE_CORRECTIONS_REPORT: 'invoice-corrections/awb-report',
  GET_ALL_CODCONFIG: 'cod/courier/cycle/all',
  UPLOAD_CODCONFIG: 'cod/courier/cycle/upload',
  COURIER_STATUS_CODCONFIG: 'cod/courier/statusMulti',
  REFRESH_S3_URL: 'tools/refreshS3Ref',
  CREATE_FRESHDESK: 'freshdesk/create',
  FILTER_FRESHDESK: 'freshdesk/filter',
  CLOSE_FRESHDESK: 'freshdesk/close',
  REOPEN_FRESHDESK: 'freshdesk/reopen',
  GET_TICKETID_FRESHDESK: 'freshdesk/get',
  REPLY_FRESHDESK: 'freshdesk/reply',
  GET_FRESHDESK_STATUS_LIST: 'freshdesk/getStatusList',
  ESCALATION_SEARCH_V2: 'escalation/search',
  ESCALATION_CREATE_V2: 'escalation/create',
  ESCALATION_STATUS_CONFIG_V2: 'escalation/config/statuses',
  ESCALATION_CATEGORY_CONFIG_V2: 'escalation/config/categories',
  // Base for detail-by-id calls — build with template literals, e.g.
  // `${apiConstants.ESCALATION_DETAIL_V2}/${id}`, `${apiConstants.ESCALATION_DETAIL_V2}/${id}/status`,
  // `${apiConstants.ESCALATION_DETAIL_V2}/${id}/remark` — same convention as CLAIMS_DETAIL.
  ESCALATION_DETAIL_V2: 'escalation',
  // Base for by-ticket-number calls (CSV bulk upload rows) — build with template literals, e.g.
  // `${apiConstants.ESCALATION_BY_NUMBER_V2}/${ticketNumber}/status`, `.../remark`.
  ESCALATION_BY_NUMBER_V2: 'escalation/by-number',
  ESCALATION_BULK_STATUS_V2: 'escalation/bulk-status',
  ESCALATION_EXPORT_V2: 'escalation/export',
  ESCALATION_STATS_V2: 'escalation/stats',
  ESCALATION_AGENT_STATS_V2: 'escalation/analytics/agents',
  ESCALATION_REPORT_SCHEDULES_V2: 'escalation/admin/report-schedules',
  // GET .../{merchantId}; POST .../{merchantId}/auto-tag and .../{merchantId}/notifications (ESCALATION_ADMIN only)
  ESCALATION_MERCHANT_SETTINGS_V2: 'escalation/admin/merchant-settings',
  ESCALATION_TAB_COUNTS_V2: 'escalation/tab-counts',
  ORDER_LISTS: 'order/search',
  B2B_ODA_CHECK: 'order/serviceability/b2b/oda',
  ORDER_INVOICE_RECONCILE: 'finance/orderInvoiceReconcile/createCustom',
  ORDER_INVOICE_RECONCILE_COURIER: 'finance/courierInvoice/recon',
  COURIER_INVOICE_FILTER: 'finance/courierInvoice/by/filter',
  LOST_AND_DAMAGE_FILTER: 'lostdamage/filter',
  LOST_AND_DAMAGE_FILTER_ACTION: 'lostdamage/action',
  LOST_AND_DAMAGE_UPLOAD_FILE: 'lostdamage/upload',
  LOST_AND_DAMAGE_STATUS: 'lostdamage/bulkActionStatus',
  UPLOAD_SKU_DETAILS: 'product/uploadSkuDetails',
  UPLOAD_LABEL_TEMPLATE: 'shippingLabel/addTemplate',
  UPLOAD_LABEL_TEMPLATE_MULTIPLECOURIER: 'shippingLabel/addMultipleTemplateForCourier',
  UPLOAD_DWS_CONFIG: 'c/dws/addUpdate',
  ENABLE_DISABLE_DWS_CONFIG: 'c/dws/enableDisable',
  GET_DWS_CONFIG: 'c/dws/getAllConfigs',
  DELETE_DWS_CONFIG: 'c/dws/delete',
  TEST_DWS_CONFIG: 'c/dws/testConfig',
  REPORT_DWS_CONFIG: 'c/dws/report',
  MERCHANT_CATEGORY: 'QCCP/findAllCategory',
  MERCHANT_CATEGORY_QUES: 'QCCP/getQCByCategory',
  MERCHANT_CATEGORY_QUES_POST: 'config/addQCQuestionsMerchantByQCCode',
  MERCHANT_QUES_LIST: 'config/getUnsavedQCCodeByCategory',
  MERCHANT_CONFIG_DELETE: 'config/deleteQCQuestionsMerchantByQCCode',
  MERCHANT_QC_LIST: 'config',
  COURIER_QC_ADD: 'QCCP/create/QC/CP',
  COURIER_QC_LIST: 'QCCP/findAll',
  COURIER_QC_LIST_BY_PARENT: 'QCCP/getByParentCourier',
  COURIER_QC_UPDATE: 'QCCP/update/QC/CP',
  COURIER_QC_DELETE: 'QCCP/delete/QC/CP',
  SAVE_NOTIFICATION: 'ui/notification/save',
  EDIT_NOTIFICATION: 'ui/notification/update',
  GET_NOTIFICATION: 'ui/notification/search',
  NPR_LISTS: 'npr/search',
  UPLOAD_IMAGES: 'tools/uploadImages',
  UPDATE_ORDER_HISTORY: 'tools/update_order_history',
  UPDATE_ORDER_HISTORY2: 'tools/updateBulkOrderHistory?remark=updateOrderHist',
  GET_UPDATED_ORDER_HISTORY: 'tools/bulkActionStatusOrderHistoryTimeUpdate',
  SERVICEABILITY2: 'tools/new/serviceability/slabs',
  FUTWORKS_CONFIG: 'config/futworksConfig',
  NDR_CALLING_STATES: 'config/ndrCalling/states',
  FUTWORKS_NPR_CONFIG: 'config/futworksConfigNpr',
  GROWUP_CONFIG: 'config/growupNextConfig',
  FUTWORK_AI_CONFIG: 'config/futworkNDRAIConfig',
  CREATE_COURIER_PARTNER: 'courierPartner/create',
  UPDATE_COURIER_PARTNER: 'courierPartner/',
  UPLOAD_BULK_TRACKING_NEW: 'order/track_uploaded_ordersv2',
  REFRESH_WALLET: 'wallet/refreshWalletCacheForMerchant',
  UPLOAD_BULK_EDDHOLIDAYS: 'system/default/saveEddHolidaysBulk',
  ADD_EDDHOLIDAYS: 'system/default/EddHolidays',
  GET_EDDHOLIDAYS: 'system/default/EDD_HOLIDAYS',
  DWS_MERCHANT_LIST: 'c/dws/getDwsMerchantListByCategory',
  DWS_LIST_BY_MERCHANT: 'c/dws/getCourierSlabsListByMerchant',
  DWS_BY_PROZOKEY: 'c/dws/getCourierSlabsListDataByCourierProzoKey',
  DWS_FOR_COURIER: 'c/dws/getCourierSlabsListByCourier',
  CHANNEL_ORDER_VERIFICATION: 'config/channelOrder/orderConfirmation',
  CHANNEL_ADDRESS_VERIFICATION: 'config/channelOrder/addressVerification',
  APPOINTMENT_DELIVERY: 'order/appointment_delivery',
  APPOINTMENT_DELIVERY_EDIT: 'order/appointment_delivery/edit',
  APPOINTMENT_DELIVERY_EDIT_CUTOFF: 'order/appointment_delivery/edit_cutoff',
  APPOINTMENT_DELIVERY_EDITS: 'order/appointment_delivery/edits',
  APPOINTMENT_DELIVERY_KAM_OWNERS: 'order/appointment_delivery/kam_owners',
  APPOINTMENT_DELIVERY_CLOSE: 'order/appointment_delivery/close',
  APPOINTMENT_DELIVERY_CONFIG: 'order/appointment_delivery/config',
  APPOINTMENT_DELIVERY_DOC_URL: 'order/appointment_delivery/doc_url',
  APPOINTMENT_DELIVERY_ADD_DOCS: 'order/appointment_delivery/add_documents',
  ADDITIONAL_DOCUMENTS: 'order/additional_documents',
  ADDITIONAL_DOCUMENTS_DOC_URL: 'order/additional_documents/doc_url',
  ADDITIONAL_DOCUMENTS_UPLOAD: 'order/additional_documents/upload',
  BUTL_UPLOAD_APPOINTMENT_DELIVERY: 'tools/upload/bulk/abd',
  BUTL_UPLOAD_APPOINTMENT_MISS: 'tools/upload/bulk/abd_miss',
  APPOINTMENT_DELIVERY_DASHBOARD: 'order/appointment_delivery/dashboard',
  APPOINTMENT_DELIVERY_EXPORT: 'order/appointment_delivery/export',
  APPOINTMENT_DELIVERY_CLOSURE_REASON: 'order/appointment_delivery/closure_reason',
  REASON_MASTER: 'reason-master',
  REASON_MASTER_CATEGORIES: 'reason-master/categories',
  ABD_PARTY_TOGGLE: 'order/abd/party/toggle',
  ABD_PARTY_CHANNEL_TAG: 'order/abd/party/channel/tag',
  ABD_PARTY_COUNT: 'order/abd/party/count',
  ABD_CHANNELS_GET: 'order/abd/channels',
  EDIT_B2C_ORDER: 'order/edit_b2c_order',
  CONFIG_COURIER_UPDATE: 'config/courier/update',
  GET_COURIER_CONFIG_BY_PROZO_ID: 'config/getCourierConfigByProzoId',
  CONFIG_COURIER_UPLOAD_BLOCKED_PINCODES_BULK: 'config/courier/uploadBlockedPincodesBulk',
  APPROVE_INSURANCE_PROPOSAL: 'insure/symbo/approveProposal',
  REJECT_INSURANCE_PROPOSAL: 'insure/symbo/cancelProposal',
  RESYNC_INSURANCE_PROPOSAL: '/insure/symbo/syncProposal',
  FETCH_INSURANCE_CERTIFICATE: 'insure/symbo/syncProposal',
  UPDATE_USER_PHONENUMBER: 'auth/update_phone_number',
  UPDATE_CHANNEL_ORDER_STATUS: 'channel/order/merchant',
  GET_MIS_FROM_AWB: 'order/readAwbFromExcelTest',
  SORTER_IMAGE_DOWNLOAD: 'tools/getBulkSorterImages',
  SORTER_IMAGE_DOWNLOAD_BY_AWB: 'tools/getBulkSorterImagesAdmin',
  GET_QC_CLICKPOST_MAPPING: 'qcClickpostMapping/all',
  GET_QC_CLICKPOST_MAPPING_BY_CP_ACCOUNT_CODE: 'qcClickpostMapping/getByCpAccountCode',
  SAVE_QC_CLICKPOST_MAPPING: 'qcClickpostMapping/saveOrUpdate',
  SAVE_AND_SEND_MAIL_TO_CLICKPOST: 'qcClickpostMapping/sendEmailToClickpost',
  PREVIEW_QC_CLICKPOST_MAPPING: 'qcClickpostMapping/viewClickpostMailTemplate',
  VIEW_DETAILS_QC_CLICKPOST_MAPPING: 'qcClickpostMapping/view',
  DELETE_QC_CLICKPOST_MAPPING: 'qcClickpostMapping',
  TOGGLE_QC_CLICKPOST_MAPPING_STATUS: 'qcClickpostMapping/switchStatus',
  ASYNC_B2B_CREATE_ORDER: 'async/b2b/order/create',
  RETURN_CONFIG: 'merchantSku/create',
  RETURN_CONFIG_UPDATE: 'merchantSku/update',
  RETURN_CONFIG_GET: 'merchantSku/getByMerchantOid',
  GET_OTP_CANCELLATION_DETAILS: 'order/getOtpCancellationDetails',
  PUSH_CHANNEL_ORDER_FULFILLMENT_TO_SHOPIFY: 'tools/pushChannelOrderFulfilmentToShopify',
  TOGGLE_APPOINTMENT_DELIVERY: 'order/toggle_appointment_delivery',
  BULK_TOGGLE_APPOINTMENT_DELIVERY: 'order/toggle_appointment_delivery/bulk',
  DWS_WEIGHT_UPLOAD: 'dwsWeight/upload',
  DWS_WEIGHT_STATUS: 'dwsWeight/status',
  DWS_WEIGHT_REPLAY: 'dwsWeight/replay',
  UPLOAD_BULK_PODS_ZIP: 'file-conversion/upload-zip-to-s3',
  GET_USER_REPORT: 'tools/getUserReport',
  GET_UNIQUE_STORE_NAMES: 'channel/order/unique-store-names',
  UNHOLD_COD: 'channel/order/merchant',
  CANCEL_CHANNEL_ORDER: 'channel/order/cancel',
  CANCEL_CHANNEL_ORDER_ITEM: 'channel/order/cancel-item',
  GENERATE_BULK_INVOICE: 'tools/generateBulkInvoice',
  GENERATE_BULK_LABELS: 'tools/generateBulkLabel',
  BULK_DOWNLOAD_LABELS: 'tools/getBulkLabelsAndPdfZip',
  GET_MERCHANT_CATEGORY: 'merchant/getMerchantCategories',
  GET_SALES_POCS: 'merchant/sales-pocs',
  SEND_OTP_FOR_USER_UPDATE: 'modify/sendotp',
  SEND_OTP_FOR_USER_MOBILE_NUMBER_UPDATE: 'modify/mobilenumber',
  SEND_OTP_FOR_USER_PII_ACCESS_UPDATE: 'modify/piiaccess',
  SEND_OTP_FOR_USER_MFA_STATUS_UPDATE: 'modify/mfastatus',
  SEND_OTP_FOR_USER_UNMASKED_ADDRESS_ACCESS_UPDATE: 'modify/unmaskedAddressAccess',
  NDR_RECORDING_SEARCH: 'ndr/recording/search',
  NPR_RECORDING_SEARCH: 'npr/recording/search',
  AUDIT_SCHEMA: 'audit/v1/schema',
  AUDIT_SEARCH: 'audit/v1/search',
  AUDIT_LOGIN_HISTORY: 'useractivity/v1/loginhistory',
  AUDIT_PASSWORD_CHANGE: 'useractivity/v1/lastpasswordchange',
  AUDIT_B2C_SHIPMENTS: 'useractivity/v1/latest-b2c-shipments',
  AUDIT_MERCHANT_REPORTS: 'useractivity/v1/merchant-reports',
  AUDIT_PII_ACCESS: 'useractivity/v1/pii-access-history',
  AUDIT_API_SECURITY: 'useractivity/v1/api-security-audit',
  DASHBOARD_CONTROLTOWER_GET_DELIVERY_METRICS:
    'external/ct/controltower/v1/wms/getDeliveryMetrics',
  DASHBOARD_CONTROLTOWER_GET_TAT_METRICS:
    'external/ct/controltower/v1/wms/getTATMetrics',
  DASHBOARD_CONTROLTOWER_GET_PICKUP_METRICS:
    'external/ct/controltower/v1/wms/getRVPPickupMetrics',

  CLAIMS_TYPES: 'claims/claimTypes',
  CLAIMS_CHECK_ELIGIBILITY: 'claims/checkEligibility',
  CLAIMS_RAISE: 'claims/raise',
  CLAIMS_LIST: 'claims/list',
  CLAIMS_DETAIL: 'claims',
  CLAIMS_UPLOAD_EVIDENCE: 'claims/uploadEvidence',
  CLAIMS_CONFIG: 'claims/config',
  // Bulk Serviceability — base: order/serviceability
  BULK_SERV_PARENT_CPS: 'order/serviceability/parent-cps',
  BULK_SERV_ACCOUNT_CODES: 'order/serviceability/account-codes',
  BULK_SERV_UPLOAD: 'order/serviceability/upload',
  BULK_SERV_AUDIT_LOG: 'order/serviceability/audit-log',
  BULK_SERV_BASE: 'order/serviceability',
  RELEASE_NOTES: 'release-notes/v1/notes',
  RELEASE_NOTES_UNREAD: 'release-notes/v1/unread-count',
  RELEASE_NOTES_SEEN: 'release-notes/v1/seen',
  // PTL Non-ABD EDD breach attribution (proship_mongo /api/ptl/nabd)
  PTL_NABD: 'ptl/nabd',
  // PTL monthly billing (proship_mongo /api/ptl/billing)
  PTL_BILLING: 'ptl/billing',
  // PoD Analytics for PTL (proship_mongo /api/pod/analytics)
  POD_ANALYTICS: 'pod/analytics',
  PTL_SETUP: 'ptl/setup',
  // PTL ODA bands and ODA pincode bands (proship_mongo /api/ptl/oda)
  PTL_ODA: 'ptl/oda',
  // Pickup drop mapping: per-merchant drop (state / pincode) → pickup pincode, used by storefronts (e.g. Shopify) for EDD (proship_mongo /api/pickup-drop-mapping)
  PICKUP_DROP_MAPPING: 'pickup-drop-mapping',
  // State / City / pincodes from pincode_master (proship_mongo /api/geo)
  GEO: 'geo',
}

export function post(endpoint, data, config) {
  return axios.post(`${ENDPOINT}${endpoint}`, data, config)
}
export function posttest(endpoint, data) {
  return axios.post(`${endpoint}`, data)
}
export function post2(endpoint, data) {
  return axios.post(`${ENDPOINT2}${endpoint}`, data)
}

export function postMultipart(endpoint, data) {
  return axios.post(`${ENDPOINT}${endpoint}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function patch(endpoint, data, config) {
  return axios.patch(`${ENDPOINT}${endpoint}`, data, config)
}

export function put(endpoint, data, config) {
  return axios.put(`${ENDPOINT}${endpoint}`, data, config)
}

export function postGeneric(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.post(`${finalUrl}`, data)
}

// For endpoints that stream back a binary file (e.g. an export download) instead of JSON.
export function postGenericBlob(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.post(`${finalUrl}`, data, { responseType: 'blob' })
}

export function patchGeneric(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.patch(`${finalUrl}`, data)
}

export function putGeneric(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.put(`${finalUrl}`, data)
}

export function deleteGeneric(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.delete(`${finalUrl}`, { data: data })
}

export function get(endpoint, params = {}, requestParams = {}) {
  const searchParams = new URLSearchParams(params)
  for (const k of Object.keys(params)) {
    searchParams.set(k, params[k])
  }

  let finalUrl = `${ENDPOINT}${endpoint}`
  if (Object.keys(params).length > 0) {
    finalUrl += `?${searchParams.toString()}`
  }

  return axios.get(finalUrl, requestParams)
}

export function getDashboardDateFilter(key = null) {
  const lastMonths = 5
  const today = new Date()
  const startOfThisMonth = startOfMonth(today)
  const dates = [
    /* {
            fromDate: formatDate(subDays(today, 15), 'yyyy-MM-dd'),
            toDate: formatDate(today, 'yyyy-MM-dd'),
            label: 'Last 15 Days',
            key: 'last_15_days'
        }, */

    {
      fromDate: formatDate(subDays(today, 7), 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'Last 7 Days',
      key: 'last_7_days',
    },
    {
      fromDate: formatDate(subDays(today, 30), 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'Last 30 Days',
      key: 'last_30_days',
    },
    {
      fromDate: formatDate(startOfThisMonth, 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'This Month',
      key: 'this_month',
    },
  ]

  for (let i = 1; i <= lastMonths; i++) {
    const stDate = startOfMonth(subMonths(startOfThisMonth, i))
    const enMonth = endOfMonth(stDate)
    dates.push({
      fromDate: formatDate(stDate, 'yyyy-MM-dd'),
      toDate: formatDate(enMonth, 'yyyy-MM-dd'),
      label: formatDate(stDate, 'MMM yyyy'),
      key: `last_${i}_month`,
    })
  }

  if (!key) return dates.find((d) => d.key === viewbyDDOptSelected)
  if (key === 'all') return dates
  return dates.find((d) => d.key === key)
}
export function getGeneric(endpoint, params = {}) {
  const searchParams = new URLSearchParams(params)
  for (const k of Object.keys(params)) {
    searchParams.set(k, params[k])
  }

  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  if (Object.keys(params).length > 0) {
    finalUrl += `?${searchParams.toString()}`
  }

  return axios.get(finalUrl)
}

export const viewbyDDOptSelected = 'last_7_days'

export function downloadZip(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  const config = {
    responseType: 'blob',
  }
  return axios.post(`${finalUrl}`, data, config)
}

export function getDownload(endpoint) {
  // responseType MUST be a top-level axios option (not under headers) — otherwise it's ignored and the
  // response is decoded as text, which corrupts binary downloads like XLSX (text/CSV happened to survive).
  return axios.get(`${endpoint}`, {
    responseType: 'blob',
  })
}
